import React from 'react';
import '../../../style/itemDropdown.scss';

function ItemEnchants({ gate, setEnchant, setGate, type, canEnchant }) {
  const enchants = [
    "None",
    "@1",
    "@2",
    "@3"
  ];

  function closeEnchantDropdown(value) {
    if(value === "None"){
      setGate(true);
      setEnchant(type,"")
      return
    }
      setGate(true);
      setEnchant(type, value);
  }
  return (
    <>
      <div
        className={`dropdownCloser ${gate && 'hidden'} ${!canEnchant && 'hidden'}`}
        onClick={() => setGate(true)}
      ></div>
      <div className={`searchOptionSelections enchantments ${gate && 'hidden'} ${!canEnchant && 'hidden'}`}>
        {enchants.map(enchant => (
          <p
            className={`enchant${enchant === "None" ? "None": enchant.split("@")[1]} option`}
            onClick={() => {
              closeEnchantDropdown(enchant);
            }}
          >
            {enchant === "None" ? "None": "Enchant "+enchant.split("@")[1]}
          </p>
        ))}
      </div>
    </>
  );
}

export default ItemEnchants;
